// extracted by mini-css-extract-plugin
module.exports =  {"button":"_025a50318d--button--FzUK3","icon":"_025a50318d--icon--yB9R1","XS":"_025a50318d--XS--JTpSd","M":"_025a50318d--M--TETjN"};